import { useMemo } from 'react';
import type { Category } from '../Categories';
import { ChartLegendItemAccordion } from './Accordion';
import { LegendItemComponent } from './LegendItemComponent';

export interface ChartLegendItemProps {
  item: Category;
  index: number;
}

export const ChartLegendItem = ({ item, index }: ChartLegendItemProps) => {
  const Component = useMemo(
    () => (!item.tooltipLabel ? LegendItemComponent : ChartLegendItemAccordion),
    [item.tooltipLabel],
  );
  return <Component item={item} index={index} />;
};
